import React, {useEffect} from 'react';
import Lottie from 'lottie-web';
import Grades from '../../../../json/splashverse-onboarding/floating-grades.json';
import GradesAU from '../../../../json/splashverse-onboarding/floating-grades-au.json';
import * as S from './style';
import LanguageKey from '../../../utils/locale-class';
import { GradeOverlappingPositions } from '../../../constant-data/splashverse-onboarding';

const FloatingGrades = ({gradeSelectionHandler}) => {

  useEffect(()=>{
    Lottie.loadAnimation({
      container: document.getElementById('grade-animation-wrapper'),
      animationData: LanguageKey() === 'au' ? GradesAU : Grades,
      loop: true,
      renderer: 'svg',
      name: 'gradeSelection',
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice', // Supports the same options as the svg element's
      }
    })
  },[])
  return (
    <S.StyledAnimation id="grade-animation-wrapper">
      {GradeOverlappingPositions.map(val=>
        <S.OpaqueCta 
          left={val.left} 
          top={val.top} 
          onClick={(e)=>gradeSelectionHandler(val.code, val.selectAnimation)}
          data-testid={`grade-${val.code}`}
        />)}
    </S.StyledAnimation>  
  )
}

export default FloatingGrades